import { createContext, useContext } from 'react';
import { AllCommonTeams } from '../ReplyCommentBox';

export interface SpecificTeamsContextType {
  enableLoadMoreTeams?: boolean;
  hasMoreTeams?: boolean;
  loadingTeams?: boolean;
  onFetchSpecificTeams?: (
    page: number,
    search: string,
    append?: boolean
  ) => void;
  specificTeams?: AllCommonTeams[];
}

const SpecificTeamsContext = createContext<SpecificTeamsContextType>({
  enableLoadMoreTeams: false,
  hasMoreTeams: false,
  loadingTeams: false,
  specificTeams: [],
});

export const useSpecificTeams = () => useContext(SpecificTeamsContext);

export default SpecificTeamsContext;
